import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import RentalRedirectionButton from 'app/components/Core/Rental/RedirectionButton'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'

const QuotePaid: React.FC<MemberProps<IQuote>> = ({ member: quote }) => {
  const { tCore } = useTranslation({ scope: 'error', recordType: RecordType.quote })

  return (
    <KCol span={24}>
      <Row className="text-center" gutter={[0, 24]}>
        <KCol offset={1} span={22}>
          <h3 className="mb-0">
            {tCore(
              {
                id: 'quote_paid_title'
              },
              { rentalCode: quote.rental_code }
            )}
          </h3>
        </KCol>
        <KCol span={24} />
        <KCol span={24}>
          <Icon type="rental_quoted" iconStyles={{ width: 65 }} />
        </KCol>
        <KCol span={24} />
        <KCol xs={{ span: 20, offset: 2 }} md={{ span: 12, offset: 6 }}>
          {tCore({ id: 'quote_paid_message' })}
        </KCol>
        <KCol span={24} />
        <KCol span={24} />
        <KCol offset={1} span={22}>
          <RentalRedirectionButton rentalId={quote?.rental_id} />
        </KCol>
        <KCol span={24} />
        <KCol span={24} />
      </Row>
    </KCol>
  )
}

export default QuotePaid
